import { render, staticRenderFns } from "./CandidateRegistration.vue?vue&type=template&id=7bcf9a46"
import script from "./CandidateRegistration.vue?vue&type=script&lang=js"
export * from "./CandidateRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports